import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { proposalCommentFilesValidator } from 'src/app/validators/proposal-comment-files-validator';

import { ProposalFileForm } from './proposal-file-form';
import { ProposalLineItemForm } from './proposal-line-item.form';

export class ProposalForm extends FormGroup<{
  id: FormControl<number | undefined>;
  ProposalRequestVendorId: FormControl<number | undefined>;
  workStartDate: FormControl<Date | undefined>;
  workFinishDate: FormControl<Date | undefined>;
  totalPrice: FormControl<string | undefined>;
  comments: FormControl<string | null>;

  ProposalLineItems: FormArray<ProposalLineItemForm>;
  ProposalFiles: FormArray<ProposalFileForm>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      ProposalRequestVendorId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      workStartDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      workFinishDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      totalPrice: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      comments: new FormControl<string | null>(null),

      ProposalLineItems: new FormArray<ProposalLineItemForm>([]),
      ProposalFiles: new FormArray<ProposalFileForm>([])
    });

    this.addValidators(proposalCommentFilesValidator);
    this.updateValueAndValidity();
  }
}
